import React, { useEffect, useState } from "react"
import axios from "axios"
import { dbURLAnyDayAlbums } from '../Constants';
import ReadMoreAndLess from "react-read-more-less";
import { Link } from "react-router-dom";
import { calculateAge } from "../misc/utils";

const isAdmin = localStorage.getItem("adminModeEgil") === "true";

const AnyDayAlbums = (props) => {
  const [albums, setAlbums] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showAllAlbums, setShowAllAlbums] = useState(false);
  const [error, setError] = React.useState(null);
  let largeArray

const ShowAllAlbumsButton = () => {
    setShowAllAlbums(true);
    };
    
    useEffect(() => {
      const fetchAlbums = () => {
        axios.get(dbURLAnyDayAlbums + props.dateSelected)
        .then(response => {
          setIsLoading(false)
          setAlbums(response.data)
        }).catch(error => {
          setError(error);
        });
      }
      fetchAlbums()
    }, [props.dateSelected])

  if (error) return `Error: ${error.message}`;

  if (isLoading) {
    return <div>
            <main className="my-4 py-4"><div className="container"> 
            <div className="row pt-5"><div className="col">
            <h4>Loading...</h4></div></div></div></main>
        </div>
}

  //fjerne duplikater
    const albumsUnique  = albums.filter(
        (obj, index) =>
          albums.findIndex((item) => item.id === obj.id) === index
      );
    //console.table(albumsUnique);
    
    //Fjerne objecter over 8 
    if (albumsUnique.length > 6 && !showAllAlbums) {
        largeArray = true
        albumsUnique.length = 6;
    }

    // Function to copy person details to clipboard
       const handleCopyAlbum = async (album) => {
        
        const ageAlbumCopy = calculateAge(album.album_release_date);

        const textToCopy = `🎉 ${album.album_released.replace(/\s+/g, " ").replace(/\b0(\d{1}),/, "$1,")}: ${album.album} (${ageAlbumCopy} years ago)\n-> https://musicthisday.com/
${album.list_unranked_name ? `-> https://www.musicthisday.com/${album.list_unranked_page}\n` : ""}\n ${album.description}`;
    
    
            try {
            await navigator.clipboard.writeText(textToCopy);
            alert(`Copied to clipboard:\n\n${textToCopy}`);
            } catch (err) {
            console.error("Failed to copy:", err);
            }
        };

  return (
    <div>

      {albumsUnique.length > 0 && (
        <div className="ml-1 mt-2 mt-md-0">

                <h2 className="text-center"><strong>ALBUMS</strong></h2>


          {albumsUnique.map(value => {

            const ageAlbum = calculateAge(value.album_release_date);


            return (
            <div key={value.id}>

                <div className="row">
                    <div className="col">
                        <div className="card shadow-sm mb-4">
                            
                            <div className="card-body">
                                {!value.youtube &&
                                    <h5 className="card-title Good rounded py-2 ps-2 pe-1">{value.album}</h5>
                                }
                                {value.youtube &&
                                    <h5 className="card-title rounded py-2 ps-2 pe-1 d-flex align-items-center custom-gradient-anyday-title">
                                        {value.album}
                                            <a href={value.youtube} target="_blank" rel="noopener noreferrer" className="ms-auto">
                                                <img 
                                                    alt="YouTube" 
                                                    className="float-end my-auto" 
                                                    style={{ height: "30px", width: "30px" }} 
                                                    src="https://imagedelivery.net/IScjm-nE3STjiSKq2Kx0QQ/520f385c-dd23-4e0d-684c-96c7ddeeb600/width=30,height=30" 
                                                />
                                            </a>
                                    </h5>
                                }
                               

                                <div className="card-text">
                                    <div className="row ReducedText">

                                    <div className="col-4">
                                        <div align="center"><img src={value.picture} 
                                        alt="" className="img-fluid rounded">
                                        </img></div>
                                            {
                                                (() => {
                                                if (value.aka) {
                                                return <div align="center" className="SmallText">
                                                <b>{value.aka}</b></div> 
                                                }
                                                return <div align="center" className="SmallText">
                                                <b>{value.artist}</b></div> 
                                                })()
                                            }
                                    </div>

                                    <div className="col-8">
                                        {
                                            (() => {
                                                if (props.dateSelected === value.released_slug) {
                                                    return <div>
                                                                <b>Released: </b><br />
                                                                <div className="DateInline p-1 rounded"><b>{value.album_released}</b> ({ageAlbum} years ago)</div>
                                                            </div>
                                                }
                                                if (value.released_slug && (props.dateSelected !== value.released_slug)) {
                                                    return <div>
                                                    <b>Released:</b><br />
                                                    <div className="DateInline p-1 rounded">{value.album_released}</div>
                                                    </div> 
                                                }
                                                return <div>
                                                    <b>Released:</b> <br />
                                                    <div className="DateInline p-1 rounded">{value.ar_text}</div>
                                                    </div>
                                            })()
                                        }
                                        {
                                            (() => {
                                            if (value.recorded_slug === props.dateSelected) {
                                                return <div className="mt-1">
                                                <b>Recorded: </b><br />
                                                <div className="DateInline p-1 rounded"><b>{value.album_recorded}</b></div>
                                                </div> 
                                            }
                                            if (value.recorded_slug && (value.recorded_slug !== props.dateSelected)) {
                                                return <div className="mt-1">
                                                <b>Recorded:</b> <br />
                                                <div className="DateInline p-1 rounded">{value.album_recorded}</div>
                                                </div> 
                                            }
                                            if (value.rd_text) {
                                                return <div className="mt-1">
                                                    <b>Recorded</b><br/> 
                                                    <div className="factText p-1 rounded">
                                                        <ReadMoreAndLess
                                                                charLimit={70}
                                                                readMoreText={" more"}
                                                                readLessText={" less"}
                                                                readMoreClassName="read-more-less--more"
                                                                readLessClassName="read-more-less--less"
                                                            >
                                                            {value.rd_text}
                                                        </ReadMoreAndLess> 
                                                    </div>
                                                </div>
                                            }
                                            return 
                                            })()
                                        }

                                        {
                                            (() => {
                                            if (value.producer) {
                                                return <div><b>Producer</b> <br />
                                                        <div className="factText p-1 rounded">
                                                            <ReadMoreAndLess
                                                                charLimit={40}
                                                                readMoreText={" more"}
                                                                readLessText={" less"}
                                                                readMoreClassName="read-more-less--more"
                                                                readLessClassName="read-more-less--less"
                                                            >
                                                            {value.producer}
                                                            </ReadMoreAndLess>
                                                        </div>
                                                </div>
                                            }
                                            return 
                                            })()
                                        }
                                    </div>

                                    </div>

                                    <div className="row mt-2 ReducedText">

                                    <div className="col">
                                        {
                                            (() => {
                                            if (value.description) {
                                            return <div className="Description mb-2">
                                                        <ReadMoreAndLess
                                                            charLimit={150}
                                                            readMoreText={" more▼"}
                                                            readLessText={" less▲"}
                                                            readMoreClassName="read-more-less--more"
                                                            readLessClassName="read-more-less--less"
                                                            >
                                                            {value.description}
                                                        </ReadMoreAndLess>
                                                        <em> -> <a href={value.wikipedia}>wikipedia</a></em>
                                                    </div>
                                            }
                                            return 
                                        })()       
                                        }

                                        {
                                            (() => {
                                            if (value.listalbumid && value.list_album_unranked_id) {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                            <div>
                                                            <b>Check out lists:</b><br /> 
                                                            <Link style = {{'fontSize': '14px'}} className="font-weight-bold text-wrap-2" 
                                                                to={value.list_page}>{value.list_name}</Link> (#{value.list_place})</div>
                                                            <div>
                                                            <Link style = {{'fontSize': '14px'}} className="font-weight-bold text-wrap-2" 
                                                                to={value.list_unranked_page}>{value.list_unranked_name}</Link>
                                                            </div>
                                                        </div>
                                            }
                                            if (value.listalbumid && !value.list_album_unranked_id) {
                                            return <div className="card p-2 mb-2 Description bg-light">
                                                        <div>
                                                        <b>Check out list:</b><br /> <Link style = {{'fontSize': '14px'}} 
                                                        className="font-weight-bold text-wrap-2" 
                                                            to={value.list_page}>{value.list_name}</Link> (#{value.list_place})
                                                        </div>
                                                        {
                                                            (() => {
                                                            if (value.artist === 'Van Morrison') {
                                                            return <div>
                                                                    <Link style = {{'fontSize': '14px'}} 
                                                                    className="font-weight-bold text-wrap-2" 
                                                                        to='/lists/ranked-songs/van-morrisons-50-greatest-songs'> Van Morrison’s 50 Greatest Songs</Link>
                                                                    </div>    
                                                            }
                                                            return 
                                                            })()    
                                                        }
                                                        {
                                                            (() => {
                                                            if (value.artist === 'David Bowie') {
                                                            return <div>
                                                                    <Link style = {{'fontSize': '14px'}} 
                                                                    className="font-weight-bold text-wrap-2" 
                                                                        to='/lists/ranked-songs/david-bowies-50-greatest-songs–ranked'> David Bowie's 50 greatest songs – ranked!</Link>
                                                                    </div>    
                                                            }
                                                            return 
                                                            })()    
                                                        }
                                                    </div>
                                            }
                                            if (value.list_album_unranked_id && !value.listalbumid) {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                            <div>
                                                            <b>Check out list:</b><br /> <Link style = {{'fontSize': '14px'}} 
                                                            className="font-weight-bold text-wrap-2" 
                                                                to={value.list_unranked_page}>{value.list_unranked_name}</Link>
                                                            </div>
                                                            {
                                                            (() => {
                                                            if (value.artist === 'Van Morrison') {
                                                            return <div>
                                                                    <Link style = {{'fontSize': '14px'}} 
                                                                    className="font-weight-bold text-wrap-2" 
                                                                        to='/lists/ranked-songs/van-morrisons-50-greatest-songs'> Van Morrison’s 50 Greatest Songs</Link>
                                                                    </div>    
                                                            }
                                                            return 
                                                            })()    
                                                            }
                                                            {
                                                                (() => {
                                                                if (value.artist === 'David Bowie') {
                                                                return <div>
                                                                        <Link style = {{'fontSize': '14px'}} 
                                                                        className="font-weight-bold text-wrap-2" 
                                                                            to='/lists/ranked-songs/david-bowies-50-greatest-songs–ranked'> David Bowie's 50 greatest songs – ranked!</Link>
                                                                        </div>    
                                                                }
                                                                return 
                                                                })()    
                                                            }
                                                        </div>
                                            }
                                            if (!value.listalbumid && value.artist === 'Bruce Springsteen') {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                        <div>
                                                            <b>Check out list:</b><br /> 
                                                                <Link style = {{'fontSize': '14px'}} 
                                                                className="font-weight-bold text-wrap-2" 
                                                                    to='/lists/ranked-songs/100-greatest-bruce-springsteen-songs'> 100 Greatest Bruce Springsteen Songs</Link>
                                                        </div>  
                                                        </div>
                                            }
                                            if (!value.listalbumid && value.artist === 'The Rolling Stones') {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                        <div>
                                                            <b>Check out list:</b><br /> 
                                                                <Link style = {{'fontSize': '14px'}} 
                                                                className="font-weight-bold text-wrap-2" 
                                                                    to='/lists/ranked-songs/100-greatest-rolling-stones-songs'> 100 Greatest Rolling Stones Songs</Link>
                                                        </div>  
                                                        </div>
                                            }
                                            if (!value.listalbumid && value.artist === 'Bob Dylan') {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                        <div>
                                                            <b>Check out list:</b><br /> 
                                                                <Link style = {{'fontSize': '14px'}} 
                                                                className="font-weight-bold text-wrap-2" 
                                                                    to='/lists/ranked-songs/the-100-best-bob-dylan-songs-recorded-in-the-60s'> The 100 Best Bob Dylan Songs Recorded in the 1960s</Link>
                                                        </div>  
                                                        </div>
                                            }
                                            if (!value.listalbumid && value.artist === 'Van Morrison') {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                        <div>
                                                            <b>Check out list:</b><br /> 
                                                                <Link style = {{'fontSize': '14px'}} 
                                                                className="font-weight-bold text-wrap-2" 
                                                                    to='/lists/ranked-songs/van-morrisons-50-greatest-songs'> Van Morrison’s 50 Greatest Songs</Link>
                                                        </div>  
                                                        </div>
                                            }
                                            if (!value.listalbumid && value.artist === 'David Bowie') {
                                                return <div className="card p-2 mb-2 Description bg-light">
                                                        <div>
                                                            <b>Check out list:</b><br /> 
                                                                <Link style = {{'fontSize': '14px'}} 
                                                                className="font-weight-bold text-wrap-2" 
                                                                    to='/lists/ranked-songs/david-bowies-50-greatest-songs–ranked'> David Bowie's 50 greatest songs – ranked!</Link>
                                                        </div>  
                                                        </div>
                                            }
                                            return 
                                            })()    
                                        }
                                    </div>

                                    </div>
                                </div>

                                {isAdmin && (props.dateSelected === value.released_slug) && (
                                    <button className="btn btn-primary btn-xxs float-end" onClick={() => handleCopyAlbum(value)}>
                                        Copy
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
  
            </div>
          )})}

            {largeArray &&
            <div className='mt-2'>
            <button id = "btn_albums" className="btn-sm btn-info" onClick = {ShowAllAlbumsButton}>Show more albums</button>
            </div>
            }
            
        </div>
      )}

    {albumsUnique.length === 0 &&
         <div className="ml-1 mt-2 mt-md-0">
            <div className="row TodayTitle24nobg mx-5">
                <div className="col-sm-12"> 
                    <div className="text-center"><b>Albums</b>
                    </div>
                    <h5>--No albums on this day--</h5>
                </div>
            </div>

        </div>
      }

    </div>
  )
}

export default AnyDayAlbums
